import { FeatureFlag, FeatureFlagLoadState } from '../enums/feature-flags.enums';
import { FeatureFlagMap } from '../models/data/feature-flag.model';

export class FeatureFlagUtilities {

  // Render gate. Hides while the load is in flight so a feature an organization does not have never
  // flashes into the nav, but treats a failed load as enabled — a failed fetch reading identically
  // to "off" would hide a feature the organization has (DEV-2730).
  public static isEnabled(flags: FeatureFlagMap | undefined, state: FeatureFlagLoadState, flag: FeatureFlag): boolean {
    if (state === FeatureFlagLoadState.Pending) {
      return false;
    }

    return flags?.[flag] !== false;
  }

  // Kill-switch read: only an explicit true counts, so an unreadable or absent flag means "off".
  // Deliberately NOT isEnabled, whose failed-load-means-enabled posture is right for a feature gate
  // but would put every user behind the maintenance page on one bad response (DEV-2731).
  public static isSwitchOn(flags: FeatureFlagMap | undefined, flag: FeatureFlag): boolean {
    return flags?.[flag] === true;
  }

  // Navigation gate. Deliberately NOT the negation of isEnabled: only an explicit server "off"
  // blocks. featureFlagGuard awaits the load before asking, so Pending here means the fetch timed
  // out or never ran - which allows, leaving the API as the enforcing gate.
  public static isBlocked(flags: FeatureFlagMap | undefined, state: FeatureFlagLoadState, flag: FeatureFlag): boolean {
    return state === FeatureFlagLoadState.Loaded && flags?.[flag] === false;
  }
}
